import React, { useState } from "react";
import Navigation from "../../Components/Navigation/Navigation";
import BackArrow from "../../Components/BackArrow/BackArrow";
import Search from "../../Components/Search/Search";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import PersonalityTable from "../../Components/Table/PersonalityTable";
import CreateModal from "../../Components/Modals/CreatePersonality";
import modalImg from "../../Assets/Images/personality.png";

const Personality = () => {
  // modal
  const [modalShow, setModalShow] = useState(false);
  // search
  const [search, setSearch] = useState("");
  return (
    <div>
      <Navigation />
      <div className="Personality-Main">
        <BackArrow to="/colors" />
        <div className="Personality-Div">
          <h3>Personality</h3>
          <div className="search-modal">
            <Search SearchValFuc={setSearch} SearchValue={search} />
            <button
              className="create"
              variant="primary"
              onClick={() => {
                setModalShow(true);
              }}
            >
              + ADD PERSONALITIES
            </button>
          </div>
          <SearchBarResults SearchValue={search} />
        </div>
        <PersonalityTable SearchValue={search} />
      </div>
      <CreateModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        head="Add a new personality"
        detail="You can add the new personality here"
        placeholder="Enter personality"
        images={modalImg}
      />
    </div>
  );
};

export default Personality;
